const specialCharacters = '!@#\\$%\\^&\\*\\(\\)_\\-\\+=\\[\\]{};\':",\\.\\/<>\\?';
export const passwordComplexityRegExp = new RegExp(
  `^(?=.*[A-Za-z])(?=.*\\d)(?=.*[${specialCharacters}])[A-Za-z\\d${specialCharacters}]{5,}$`
);
